<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="apiLoaded" class="wrap">
        <div class="list passport" v-if="configChecklist != null">
          <div class="list-item-wrap">
            <v-expansion-panels>
              <ActivityMonitorChecklistSection
                  v-for="sectionName in configChecklistSectionNames"
                  :key="sectionName"
                  :region-and-department-info="regionAndDepartmentInfo"
                  :title="sectionName"
                  :checklist-config="configChecklistSections[sectionName]"
                  :checklist-values="getChecklistValuesBySectionName(sectionName)"
                  :file-config="getFileConfigBySectionName(sectionName)"
                  :file-values="getFileValuesBySectionName(sectionName)"
                  :period="period"
                  @updated="editDialogUpdated"
              ></ActivityMonitorChecklistSection>
            </v-expansion-panels>
          </div>
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
  </div>
</template>

<script>
import {getCznIndicatorsByPeriod, getRegionIndicatorsByPeriod} from "@/modules/api.indicators";
import ActivityMonitorChecklistSection from "./ActivityMonitorChecklistSection.vue";

export default {
  name: "ActivityMonitorCheckList",
  components: {ActivityMonitorChecklistSection},
  props: ['regionAndDepartmentInfo', 'period', 'configChecklist', 'configFiles', 'configIndicators', 'regions'],
  watch: {
    regionAndDepartmentInfo: {
      async handler() {
        this.apiLoaded = false;
        await this.initialize();
        this.$forceUpdate();
        this.apiLoaded = true;
      },
      deep: true
    },
    period: {
      async handler() {
        this.apiLoaded = false;
        await this.initialize();
        this.$forceUpdate();
        this.apiLoaded = true;
      }
    },
  },
  data: () => ({
    domain: "activity_monitor",
    configChecklistSections: [],
    configChecklistSectionNames: [],
    indicatorValues: [],
    apiLoaded: false,
  }),
  methods: {
    async initialize() {
      await this.loadValues();
      this.computeConfigChecklistSections();
    },
    computeConfigChecklistSections() {
      const sectionField = this.regionAndDepartmentInfo.department == null
          ? 'regionSection'
          : 'cznSection'
      this.configChecklistSectionNames = [...new Set(this.configChecklist.map(e => e[sectionField]))].filter(e => e != null && e !== 'null')
      this.configChecklistSections = {}
      for (let sectionName of this.configChecklistSectionNames) {
        this.configChecklistSections[sectionName] = this.configChecklist.filter(e => e[sectionField] === sectionName);
      }
    },
    async loadValues() {
      if (this.regionAndDepartmentInfo.department == null) {
        this.indicatorValues = (await getRegionIndicatorsByPeriod(
            this.domain,
            this.regionAndDepartmentInfo.region.code,
            this.period.code,
            "EMPTY"
        )).payload
      } else {
        this.indicatorValues = (await getCznIndicatorsByPeriod(
            this.domain,
            this.regionAndDepartmentInfo.department.id,
            this.period.code
        )).payload
      }
    },
    getChecklistValuesBySectionName(sectionName) {
      const result = [];
      for (let value of this.indicatorValues) {
        for (let configIndicator of this.configChecklistSections[sectionName]) {
          if (value.indicatorId === configIndicator.id) {
            result.push(value);
          }
        }
      }
      return result;
    },
    getFileValuesBySectionName(sectionName) {
      const result = [];
      for (let value of this.indicatorValues) {
        for (let configIndicator of this.configFiles) {
          if (configIndicator.section === sectionName && value.indicatorId === configIndicator.id) {
            result.push(value);
          }
        }
      }
      return result;
    },
    getFileConfigBySectionName(sectionName) {
      for (let configIndicator of this.configFiles) {
        if (configIndicator.section === sectionName) {
          return configIndicator;
        }
      }
    },
    async editDialogUpdated() {
      await this.loadValues();
      this.$forceUpdate()
    },
  },
  async beforeMount() {
    await this.initialize()
    this.apiLoaded = true;
  },
}
</script>

<style scoped lang="scss">
@import "../../styles/main.scss";

h1 {
  display: flex;
  align-items: center;

  .badge {
    width: 152px;
    height: 60px;
    background: #E8E8E9;
    border: 1px solid #E8E8E9;
    border-radius: 4px;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 70px;
    color: $cblack;
  }

  .v-progress-circular {
    margin-left: 20px;
  }

  .v-btn {
    margin-left: auto;
  }
}

.manual-link {
  margin: 20px 0;

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-bottom: 20px;

    .v-icon {
      color: #0033a0;
      margin-right: 10px;
    }
  }
}

.list {
  .list-item-wrap {
    padding: 5px 0;
  }

  table {
    margin-bottom: 25px;

    th {
      padding: 5px 20px 5px 0;

      div.v-dialog__container + div {
        height: 240px;
        cursor: pointer;
      }

      span {
        display: flex;
        justify-content: flex-start;
        gap: 3px;
        min-width: min(150px, 20vw);
      }

      &:first-child {
        text-align: center;
        width: 100%;
      }
    }

    td {
      padding: 5px 20px 5px 0;
      border-top: 1px solid #E8E8E9;
      border-bottom: 0;

      & > div {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        svg {
          margin-right: 8px;
          flex-shrink: 0;
          margin-top: 5px;
          width: 20px;
        }

        a {
          white-space: nowrap;
        }
      }
    }

    tr:last-child {
      td {
        border-top: 1px solid #E8E8E9;
      }
    }
  }
}

.clientindex {
  .v-expansion-panel.level2 {
    padding-left: 30px;
    padding-top: 0px;

    .list-item-wrap {
      border-bottom: 0;
    }

    & + .v-expansion-panel.level2 {
      .list-item-wrap {
        border-top: 1px solid #E8E8E9;
      }
    }
  }
}

.push-right {
  float: right;
  margin-top: 15px;
}

.v-progress-circular__info {
  font-size: 13px !important;
  text-align: center;
  width: 100%;
}
</style>
